import {css} from "@pandacss/css";
import {createPandaComponent} from "../helpers/pandaComponent.ts";
import {font} from "../style/typography.tsx";

const textOutputClass = css({
    backgroundColor: "neutral.700",
    border: "1px solid",
    borderColor: "neutral.500",
    borderRadius: "12px",
    padding: "14px 12px",
    overflowX: "auto",
})

const TextOutput = createPandaComponent('TextOutput', 'div', [textOutputClass, font('body', '2', 'regular')]);

export default TextOutput;